import BaseApi from './BaseApi';

import { GetNewsProps, MarkNewsItemProps } from 'models';

class NewsApi extends BaseApi {
	constructor() {
		super('/investor/news');
	}

	getTitles({ params, lang }: GetNewsProps) {
		return this.httpClient.get({
			url: `/only-title/${lang}`,
			conditions: { version: 'v2', auth: true },
			config: { params },
		});
	}

	getAll({ params, lang }: GetNewsProps) {
		return this.httpClient.get({
			url: `/title-and-preview/${lang}`,
			conditions: { version: 'v2', auth: true },
			config: { params },
		});
	}

	getPieceOfNews({ newsUuid, lang }: MarkNewsItemProps) {
		return this.httpClient.get({
			url: `/${newsUuid}/${lang}`,
			conditions: { version: 'v2', auth: true },
		});
	}

	markAsRead({ lang, newsUuid }: MarkNewsItemProps) {
		return this.httpClient.post({
			url: `/${newsUuid}/${lang}/mark-read`,
			conditions: { version: 'v2', auth: true },
		});
	}

	markAsUnread({ lang, newsUuid }: MarkNewsItemProps) {
		return this.httpClient.post({
			url: `/${newsUuid}/${lang}/mark-unread`,
			conditions: { version: 'v2', auth: true },
		});
	}

	readAll(lang: string) {
		return this.httpClient.post({
			url: `/${lang}/mark-read-all`,
			conditions: { version: 'v2', auth: true },
		});
	}
}

export const NewsService = new NewsApi();
